import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { Home } from '@/pages/Home';
import { Exercises } from '@/pages/Exercises';
import { ExercisePlayer } from '@/pages/ExercisePlayer';
import { About } from '@/pages/About';
import { Contact } from '@/pages/Contact';
import '@/App.css';

function App() {
    return (
        <BrowserRouter>
            <div className="App min-h-screen flex flex-col">
                <Navigation />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/exercises" element={<Exercises />} />
                        <Route path="/exercise/:exerciseId" element={<ExercisePlayer />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="top-center" richColors />
            </div>
        </BrowserRouter>
    );
}

export default App;